export default "__VITE_ASSET__BQvvkVkY__"